export default async () => {
  document.querySelector('main')?.empty?.();

  await create({
    element: 'section',
    parent: 'main',
    class: 'main-contact',
    isGrid: true,
    content: [
      { element: 'h2', text: dic?.branding?.menu?.contact || 'Contato', class: 'center' },
      {
        element: 'p',
        text: dic?.message?.contactIntro || 'Entre em contato para conhecer a plataforma e tirar duvidas comerciais.'
      }
    ]
  });
};
